
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ConstantContactEmailCampaignActivityPreview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConstantContactEmailCampaignActivityPreview"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaignActivityId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fromEmail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fromName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"preheader"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"previewHtmlContent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"previewTextContent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"replyToEmail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subject"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":243}};
    doc.loc.source = {"body":"fragment ConstantContactEmailCampaignActivityPreview on ConstantContactEmailCampaignActivityPreview {\n    campaignActivityId\n    fromEmail\n    fromName\n    preheader\n    previewHtmlContent\n    previewTextContent\n    replyToEmail\n    subject\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
